import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface UseGetLimitsIframeProps {
    customerId: string;
    accountExternalId: string;
}

export const UseGetLimitsIframe = ({ customerId, accountExternalId }:UseGetLimitsIframeProps) => useQuery(
  'UseGetLimitsIframe',
  async () => {
    const res = await httpService.get(
      `${BASE_URL}/api/v1/user/${customerId}/account/${accountExternalId}/limits`,
      {
        data: {
          template_id: 'account_limits',
        },
        responseType: 'blob',
      },
    );
    const htmlUrl = URL.createObjectURL(res.data);

    return htmlUrl;
  },
  {
    enabled: false,
    retry: 0,
    staleTime: 0,
    cacheTime: 0,
  },
);
